import type { WorkspaceDefinition } from '@/core/ui/workspace'

// docs/upgrade/06 §4 nhóm Hành chính & Nhân sự (đợt M2). Đơn từ, lịch, suất ăn mở cho mọi tài khoản đăng nhập (ADR-022 Q24, ADR-068).
const ledger = () => import('@/modules/workforce/OperationalLedgerView.vue')

export const requestsWorkspace: WorkspaceDefinition = {
  tabs: [
    // 12/10/2026: Hồ sơ tiếp nhận — tab ĐẦU TIÊN, gộp tiếp nhận của Nhân sự (HCNS) và Kế toán; chỉ hiện khi có quyền đọc ít nhất một
    // bên (AdministrativeReceipts.Read / AccountingReceipts.Read, khớp policy backend). Người không có quyền vào thẳng tab đơn như cũ.
    { key: 'receipts', labelKey: 'workforceAdmin.receipts.combinedTitle', icon: 'pi pi-inbox', permission: ['AdministrativeReceipts.Read', 'AccountingReceipts.Read'], permissionMode: 'any',
      component: () => import('@/modules/workforce/AccountingReceiptsView.vue') },
    { key: 'leave', labelKey: 'nav.leaveRequests', icon: 'pi pi-calendar-minus', component: ledger, props: { requestType: 'Leave' } },
    { key: 'overtime', labelKey: 'nav.overtimeRequests', icon: 'pi pi-history', component: ledger, props: { requestType: 'Overtime' } },
    { key: 'business-trip', labelKey: 'nav.businessTrips', icon: 'pi pi-briefcase', component: ledger, props: { requestType: 'BusinessTrip' } },
    { key: 'attendance-correction', labelKey: 'nav.attendanceCorrections', icon: 'pi pi-clock', component: ledger, props: { requestType: 'TimeCorrection' } },
    { key: 'vehicle', labelKey: 'nav.vehicleRequests', icon: 'pi pi-car', component: ledger, props: { requestType: 'Vehicle' } },
    // Mọi tài khoản xem số dư phép của mình; AnnualLeave.Read mới xem sổ phép của người khác (trong màn tự kiểm).
    { key: 'annual-leave', labelKey: 'annualLeave.title', icon: 'pi pi-calendar',
      component: () => import('@/modules/workforce/AnnualLeaveView.vue') },
  ],
}

// Q2 (11/10/2026): Chấm công chuyển từ nhóm Dự án sang Nhân sự.
// ADR-108 (27/10/2026): bỏ hai tab «Báo cáo công việc hàng ngày» (ghi giờ nay ở Dự án › Của tôi; khóa kỳ, công suất, nhật ký kỳ,
// máy chấm công chuyển vào Chấm công quản trị) và «Tổ của tôi» (nay là góc nhìn «Theo tổ» trong Hộp phê duyệt › Chấm công).
export const attendanceWorkspace: WorkspaceDefinition = {
  tabs: [
    { key: 'calendar', labelKey: 'nav.workCalendar', icon: 'pi pi-calendar', component: () => import('@/modules/calendar/WorkCalendarPage.vue') },
    { key: 'administration', labelKey: 'nav.attendanceAdministration', icon: 'pi pi-calendar-clock', permission: 'Attendance.Read',
      component: () => import('@/modules/workforce/AttendanceAdministrationView.vue') },
  ],
}

export const payrollWorkspace: WorkspaceDefinition = {
  tabs: [
    { key: 'payroll', labelKey: 'payroll.title', icon: 'pi pi-wallet', permission: 'Payroll.Read', component: () => import('@/modules/workforce/PayrollView.vue') },
    { key: 'mine', labelKey: 'payroll.mineTitle', icon: 'pi pi-file-pdf', permission: 'Payroll.ReadOwn', component: () => import('@/modules/workforce/MyPayslipsView.vue') },
    { key: 'manday-cost', labelKey: 'nav.mandayCost', icon: 'pi pi-wallet', permission: ['MandayCosts.Read', 'MandayCosts.ReadSensitive'], permissionMode: 'all', component: () => import('@/modules/workforce/MandayCostView.vue') },
  ],
}

export const administrationWorkspace: WorkspaceDefinition = {
  tabs: [
    { key: 'vehicles', labelKey: 'nav.companyVehicles', icon: 'pi pi-wrench', permission: 'CompanyVehicles.Read',
      component: () => import('@/modules/workforce/CompanyVehiclesView.vue') },
    { key: 'meals', labelKey: 'nav.mealRegistrations', icon: 'pi pi-shop', component: () => import('@/modules/workforce/MealRegistrationMatrixView.vue') },
    { key: 'documents', labelKey: 'nav.controlledDocuments', icon: 'pi pi-folder-open', permission: 'Documents.Read',
      component: () => import('@/modules/documents/ControlledDocumentRegisterView.vue') },
  ],
}
